import * as React from 'react';
import { useAuth } from '@components/amplifyProvider';
import AvCopilot from '@components/Copilot/AvCopilot';
import { loadingPage } from '@fabric-ui/components';
import { envVariables } from '@fabric-ui/utils';
import { Box } from '@mui/material';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { getAccountTokenFromLS } from '@utils/auth.utils';
import { TanStackRouterDevtools } from '@utils/AvRouter';
import { AuthStorageKeys } from '@utils/localStorageAuthUtils.utils';
import AvAppBar from '../components/newNavigation/AvAppBar';
import AvSidebar from '../components/newNavigation/AvSideBar';
import { useAvContext } from '../context/AvContextProvider';
import { useAvCopilotContext } from '../context/AvCopilotProvider';
import { useAvDebugContext } from '../context/AvDebugProvider';
import RootContext from '../context/RootContext';
import { useAppVersion } from '../hooks/useAppVersion';
import { RouterContextType } from '../RouterContext';
import { FeatureFlags } from '../types';

export const Route = createRootRouteWithContext<RouterContextType>()({
  component: Rootroot,
  beforeLoad: () => ({
    hideBreadcrumbs: false,
    getTitle: () => '',
  }),
});
function Rootroot() {
  return (
    <RootContext>
      <RootComponent />
    </RootContext>
  );
}

export const Main = ({ children }: React.PropsWithChildren) => (
  <Box component="main" aria-label="workspace" sx={{ gridArea: 'main' }}>
    {children}
  </Box>
);

function RootComponent() {
  const { isLoading, isAuthenticated, accountId, featureFlags } = useAvContext();
  const { isOpen } = useAvCopilotContext();
  const { showDevTools } = useAvDebugContext();
  const isLoggedIn = localStorage.getItem(AuthStorageKeys.authConfig);
  const { logout } = useAuth();
  useAppVersion();
  if (!isAuthenticated) {
    if (isLoading) {
      if (!getAccountTokenFromLS(accountId)) {
        return loadingPage(!!isLoggedIn);
      }
    } else if (envVariables.MODE !== 'development') {
      logout(!!getAccountTokenFromLS(accountId));
      return loadingPage(!!isLoggedIn);
    }
  }
  return (
    <>
      <AvAppBar />
      <AvSidebar />
      <Main>
        <Outlet />
      </Main>
      {(featureFlags[FeatureFlags.ShowAgentsCopilot] || featureFlags[FeatureFlags.RemediationCopilot]) && isOpen && <AvCopilot />}
      {showDevTools && <TanStackRouterDevtools />}
    </>
  );
}
